// extracted by mini-css-extract-plugin
module.exports = {"icon":"Icon_icon__2G3kg","withIndication":"Icon_withIndication__aLy-h"};